import { attributesToProps } from 'html-react-parser';
import * as React from 'react';

export const replaceDolVnToLandingBlogMainSite = (content) => {
  if (!content) return content;
  return content
    .replace(/dol\.vn/g, 'dolenglish.vn')
    .replace(/dolacademy\.vn/g, 'dolenglish.vn')
    .replace(/grammar\.dolenglish\.vn/g, 'dolenglish.vn')
    .replace(/https:\/\/dolenglish\.vn/g, 'https://www.dolenglish.vn');
};
const replaceImageCDNPath = (content) => {
  return content.replace('suijm9clouobj.vcdn.cloud', 'media.dolenglish.vn');
};

export const replaceLandingBlogCanonicalUrl = (domNode: any) => {
  if (domNode?.attribs?.rel === 'canonical') {
    return <link rel="canonical" href={replaceDolVnToLandingBlogMainSite(domNode.attribs.href)} />;
  }
  if (domNode?.attribs?.property === 'og:url') {
    return (
      <meta
        property="og:url"
        content={replaceDolVnToLandingBlogMainSite(domNode?.attribs?.content)}
      />
    );
  }
  if (domNode?.attribs?.property === 'og:image') {
    return <meta property="og:image" content={replaceImageCDNPath(domNode?.attribs?.content)} />;
  }
  if (domNode?.attribs?.property === 'twitter:url') {
    return (
      <meta
        property="twitter:url"
        content={replaceDolVnToLandingBlogMainSite(domNode?.attribs?.content)}
      />
    );
  }
  if (domNode?.attribs?.name === 'twitter:image') {
    return <meta name="twitter:image" content={replaceImageCDNPath(domNode?.attribs?.content)} />;
  }
  if (domNode?.name === 'meta') {
    const aProps = attributesToProps(domNode.attribs);
    return (
      <meta {...aProps} key={domNode.attribs.property || domNode.attribs.name || domNode.name} />
    );
  }
  return domNode;
};
